<template>
  <div class="fees_block">
    <div class="left">
      <h3 class="large_blue_label">サービス利用手数料について。</h3>
      <p class="marker-underline_label">クライアントから手数料は頂きません。</p>
      <p class="marker-underline_label">オペレーターから税込契約金額の20％の手数料を頂戴します。</p>
      <p class="strong_label">※β版期間はオペレーターの手数料を8%といたします。</p>
      <br>
      <p>オペレーターが得た報酬はフルーのアカウント上に貯められ、オペレーターの任意のタイミングでオペレーターの銀行口座へ出金することができます。</p>
      <p>ただし、出金は1回/月とし、1回あたり250円（税抜）の手数料が別途発生します。</p>
      <br>
      <p class="small_label">フルーのアカウント上に貯められた報酬の保管期限は60日間とします。</p>
      <p class="small_label">それを過ぎると自動的にオペレーターの銀行口座へ出金されます。</p>
      <p class="small_label">その場合も1回あたり250円（税抜）の手数料が発生します。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/service_3.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "FeesBlock"
  }
</script>

<style lang="scss" scoped>
  .fees_block {
    @include double_columns(40%, 35%);

    .large_blue_label {
      margin-bottom: 2rem;
    }

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>